import { render } from "./FormCode.vue?vue&type=template&id=35327e2c&scoped=true"
import script from "./FormCode.vue?vue&type=script&lang=js"
export * from "./FormCode.vue?vue&type=script&lang=js"

import "./FormCode.vue?vue&type=style&index=0&id=35327e2c&lang=css&scoped=true"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35327e2c"]])

export default __exports__